import React from "react";
import { LOGO_SRC } from "@/components/BrandMark";

export const ProductImage = ({ product, className = "" }) => {
  if (product.image) {
    return <img src={product.image} alt={product.name} className={`w-full h-full object-cover ${className}`} />;
  }
  return (
    <div
      data-testid={`product-image-pending-${product.id}`}
      className="w-full h-full flex flex-col items-center justify-center gap-2 bg-emerald-50 dark:bg-emerald-900"
    >
      <img src={LOGO_SRC} alt="U&URS NUTRITIONIST" className="w-1/2 h-auto rounded-xl" />
      <span className="text-[10px] font-semibold uppercase tracking-wider text-emerald-600 dark:text-emerald-300">Image coming soon</span>
    </div>
  );
};
